/**
 * C 端情报瀑布接口。
 */
import { post } from "../../utils/backend";
import { useLongfansMock } from "../../global/GlobalMock";
import type {
  IntelligenceFeedEngagementParam,
  IntelligenceFeedEngagementState,
  IntelligenceFeedListQuery,
  IntelligenceFeedListKind,
  IntelligenceFeedListResult,
} from "./IntelligenceFeedType";
import {
  mockIntelligenceFeedList,
  mockToggleIntelCollect,
  mockToggleIntelLike,
} from "./IntelligenceFeedMock";

/** 本地调试情报 Mock 时改为 useLongfansMock；关闭 Mock 时 `&& false` */
const mockIntelligence = useLongfansMock && false;

const URL_LIST =
  process.env.REACT_APP_INTELLIGENCE_LIST_FEED_URL?.trim() ||
  "/lark/app/intelligence/listFeed";
const URL_LIST_LIKED =
  process.env.REACT_APP_INTELLIGENCE_LIST_FEED_LIKED_URL?.trim() ||
  "/lark/app/intelligence/listFeedLiked";
const URL_LIST_COLLECTED =
  process.env.REACT_APP_INTELLIGENCE_LIST_FEED_COLLECTED_URL?.trim() ||
  "/lark/app/intelligence/listFeedCollected";
const URL_TOGGLE_LIKE =
  process.env.REACT_APP_INTELLIGENCE_TOGGLE_LIKE_URL?.trim() ||
  "/lark/app/intelligence/toggleIntelLike";
const URL_TOGGLE_COLLECT =
  process.env.REACT_APP_INTELLIGENCE_TOGGLE_COLLECT_URL?.trim() ||
  "/lark/app/intelligence/toggleIntelCollect";

function listUrl(kind: IntelligenceFeedListKind): string {
  if (kind === "liked") {
    return URL_LIST_LIKED;
  }
  if (kind === "collected") {
    return URL_LIST_COLLECTED;
  }
  return URL_LIST;
}

export const IntelligenceFeedApi = {
  async list(
    kind: IntelligenceFeedListKind,
    query: IntelligenceFeedListQuery
  ): Promise<IntelligenceFeedListResult | string> {
    if (mockIntelligence) {
      return mockIntelligenceFeedList(query, kind);
    }
    return post<IntelligenceFeedListQuery, IntelligenceFeedListResult>(listUrl(kind), query, {
      silent: true,
    });
  },

  async toggleLike(
    param: IntelligenceFeedEngagementParam
  ): Promise<IntelligenceFeedEngagementState | string> {
    if (mockIntelligence) {
      return mockToggleIntelLike(param);
    }
    return post<IntelligenceFeedEngagementParam, IntelligenceFeedEngagementState>(
      URL_TOGGLE_LIKE,
      param,
      { silent: true }
    );
  },

  async toggleCollect(
    param: IntelligenceFeedEngagementParam
  ): Promise<IntelligenceFeedEngagementState | string> {
    if (mockIntelligence) {
      return mockToggleIntelCollect(param);
    }
    return post<IntelligenceFeedEngagementParam, IntelligenceFeedEngagementState>(
      URL_TOGGLE_COLLECT,
      param,
      { silent: true }
    );
  },
};
